/**
 * Disposition de la grille de tuiles vidéo — PURE (aucune dépendance React/DOM), testable
 * sans navigateur. Mobile-first : 1 tuile pleine largeur, 2 en colonnes dès `sm`, 3-4 en 2×2,
 * 5-8 dans une grille qui défile (le plafond de confort du maillage WebRTC, cf.
 * `bitrate-budget.ts`) — au-delà, même disposition, juste plus de lignes à faire défiler.
 *
 * ⚠️ Les classes retournées doivent apparaître ICI, en clair : Tailwind v4 scanne le TEXTE des
 * fichiers listés en `@source`, pas leur exécution — une classe assemblée dynamiquement à partir
 * de fragments qui n'apparaissent nulle part tels quels ne serait jamais générée.
 */

export type GridDensity = 'single' | 'pair' | 'quad' | 'scroll';

/** Identifiant réservé de la tuile locale (« Toi ») dans les API de mise en avant (spotlight). */
export const LOCAL_TILE_ID = '__local__';

/** Catégorise le nombre de tuiles — sert aux tests et à documenter les seuils. */
export function gridDensity(tileCount: number): GridDensity {
  if (tileCount <= 1) return 'single';
  if (tileCount === 2) return 'pair';
  if (tileCount <= 4) return 'quad';
  return 'scroll';
}

/** Classes Tailwind du conteneur de grille, selon le nombre de tuiles (0 traité comme 1). */
export function gridContainerClass(tileCount: number): string {
  switch (gridDensity(tileCount)) {
    case 'single':
      return 'grid grid-cols-1 gap-3';
    case 'pair':
      return 'grid grid-cols-1 gap-3 sm:grid-cols-2';
    case 'quad':
      return 'grid grid-cols-2 gap-3';
    case 'scroll':
      return 'grid max-h-[60vh] grid-cols-2 gap-3 overflow-y-auto pr-1 sm:grid-cols-3 sm:max-h-[70vh]';
  }
}
